import { createContext, useContext } from "react";
import type { SearchContextType } from "../features/search/searchContexts.js";

export interface AppSearchContextValue {
  /** Whether search is open and temporarily owns the active nav state. */
  isSearchActive: boolean;
  openSearch: () => void;
  /**
   * Registers the search context for the active section. Returns a cleanup that
   * clears it, so the section that mounts the trigger owns which search opens.
   */
  registerSearchContext: (context: SearchContextType) => () => void;
}

// Defaults to inactive/no-op so a search trigger degrades gracefully when
// rendered outside an `AppSearchProvider` (e.g. in isolation).
export const AppSearchContext = createContext<AppSearchContextValue>({
  isSearchActive: false,
  openSearch: () => {},
  registerSearchContext: () => () => {},
});

export function useAppSearch(): AppSearchContextValue {
  return useContext(AppSearchContext);
}
